import { FC } from "react";
import BrandLogo from "./BrandLogo";
import UserProfileMenu from "./UserProfileMenu";
import { Divider } from "@heroui/react";
import { TLoggedInUserInfo } from "../../types/loggedInUserInfo";
import ContactUs from "../../../features/contact-us/ContactUs";

interface IHeaderProps {
  loggedInUserInfo: TLoggedInUserInfo | null;
}

const Header: FC<IHeaderProps> = ({ loggedInUserInfo }) => {
  return (
    <>
      <div className="flex h-24 items-center justify-between p-4">
        <div className="flex-1">
          <BrandLogo />
        </div>
        <div className="flex-1 flex items-center space-x-4 justify-end">
          {loggedInUserInfo && (
            <>
              <ContactUs />
              <UserProfileMenu loggedInUserInfo={loggedInUserInfo} />
            </>
          )}
        </div>
      </div>
      <Divider orientation="horizontal" className="px-0 mx-0" />
    </>
  );
};

export default Header;
